<script setup lang="ts">
import { IonAlert, type AlertButton } from '@ionic/vue'
defineProps<{
	show: boolean
	title?: string
	buttons?: AlertButton[]
	type?: 'submit'
	disabled?: boolean
	btnClass?: string
}>()

const emits = defineEmits(['close'])

</script>

<template>
	<ion-alert
		:is-open="show"
		:header="title"
		:buttons="buttons"
		@did-dismiss="emits('close')"></ion-alert>
</template>

